export default {
  success: 'Payment Success',
  failure: 'Payment Failed',
  paymentSuccessful: 'Payment successful',
  paymentFailed: 'Payment failed',
  redirecting: '{seconds}s Then redirected to {target}',
  closeTips: '{seconds}s Then close',
}
